import { Flex, Heading, Text, IconProps } from '@chakra-ui/react';
import { ComponentWithAs } from '@chakra-ui/system';
import React from 'react';

type Props = {
  title: string;
  icon: ComponentWithAs<'svg', IconProps>;
  description: string;
  color: string;
};

const BenefitItem = ({ icon: Icon, color, description, title }: Props) => (
  <Flex direction="column">
    <Icon boxSize={[8, null, 12]} color={color} />
    <Heading
      textAlign="start"
      mt={[7, null, 9]}
      as="h3"
      size="lg-md"
      color={color}
    >
      {title}
    </Heading>
    <Text mt={3}>{description}</Text>
  </Flex>
);

export default BenefitItem;
